import { createSelector } from 'reselect'

const uiSelector = state => state.ui

export default createSelector(
	[uiSelector],
	uiDataSelector => uiDataSelector ? uiDataSelector : null
)
